import AddPlus from './AddPlus.vue'
import AgreementProgress from './AgreementProgress.vue'
import Alarm from './Alarm.vue'
import AppendFile from './AppendFile.vue'
import Bell from './Bell.vue'
import Camera from './Camera.vue'
import CertGuide1 from './CertGuide1.vue'
import CertGuide2 from './CertGuide2.vue'
import CertGuide3 from './CertGuide3.vue'
import CertGuide4 from './CertGuide4.vue'
import CertGuide5 from './CertGuide5.vue'
import CertGuide6 from './CertGuide6.vue'
import CheckInBlueCircle from './CheckInBlueCircle.vue'
import CheckInCircle from './CheckInCircle.vue'
import CheckMark from './CheckMark.vue'
import CircularProgress from './CircularProgress.vue'
import Coin from './Coin.vue'
import CompanyIcon from './CompanyIcon.vue'
import CompanyIndividualIcon from './CompanyIndividualIcon.vue'
import CompletedIcon from './CompletedIcon.vue'
import Consult from './Consult.vue'
import Corporate from './Corporate.vue'
import Dash from './Dash.vue'
import Delay from './Delay.vue'
import DetachFile from './DetachFile.vue'
import DoubleQuote from './DoubleQuote.vue'
import DownAngleBracket from './DownAngleBracket.vue'
import EasyCertStep from './EasyCertStep.vue'
import ExclamationMark from './ExclamationMark.vue'
import Financial from './Financial.vue'
import HamburgMark from './HamburgMark.vue'
import Hero1 from './Hero1.vue'
import Hero2 from './Hero2.vue'
import Hero3 from './Hero3.vue'
import Hero4 from './Hero4.vue'
import HeumOverTaxLogo from './HeumOverTaxLogo.vue'
import HomeTaxDelay from './HomeTaxDelay.vue'
import HeumTaxLogo from './HeumTaxLogo.vue'
import IDBack from './IDBack.vue'
import IDFront from './IDFront.vue'
import Individual from './Individual.vue'
import Info from './Info.vue'
import Info2 from './Info2.vue'
import InvalidTarget from './InvalidTarget.vue'
import LeftArrow from './LeftArrow.vue'
import Moms from './Moms.vue'
import Money from './Money.vue'
import MoneyGreen from './MoneyGreen.vue'
import MonitorIcon from './MonitorIcon.vue'
import Mute from './Mute.vue'
import NaverApp from './NaverApp.vue'
import Notice from './Notice.vue'
import OverTaxLogo from './OverTaxLogo.vue'
import Pen from './Pen.vue'
import PhoneRing from './PhoneRing.vue'
import Question from './Question.vue'
import Refresh from './Refresh.vue'
import RefundProcess from './RefundProcess.vue'
import RefundProgressBar from './RefundProgressBar.vue'
import RelativeIcon from './RelativeIcon.vue'
import Review from './Review.vue'
import RightAngleBracket from './RightAngleBracket.vue'
import Shield from './Shield.vue'
import ShieldCheck from './ShieldCheck.vue'
import ShieldExclamation from './ShieldExclamation.vue'
import Speak from './Speak.vue'
import Stars5 from './Stars5.vue'
import SurveyStart from './SurveyStart.vue'
import Triangle from './Triangle.vue'
import TossApp from './TossApp.vue'
import UpAngleBracket from './UpAngleBracket.vue'
import VideoPlayButton from './VideoPlayButton.vue'
import Warning from './Warning.vue'
import XMark from './XMark.vue'

export const Icon = [
  AddPlus,
  AgreementProgress,
  Alarm,
  AppendFile,
  Bell,
  Camera,
  CertGuide1,
  CertGuide2,
  CertGuide3,
  CertGuide4,
  CertGuide5,
  CertGuide6,
  CheckInBlueCircle,
  CheckInCircle,
  CheckMark,
  CircularProgress,
  Coin,
  CompanyIcon,
  CompanyIndividualIcon,
  CompletedIcon,
  Consult,
  Corporate,
  Dash,
  Delay,
  DetachFile,
  DoubleQuote,
  DownAngleBracket,
  EasyCertStep,
  ExclamationMark,
  Financial,
  HamburgMark,
  Hero1,
  Hero2,
  Hero3,
  Hero4,
  HeumOverTaxLogo,
  HomeTaxDelay,
  HeumTaxLogo,
  IDBack,
  IDFront,
  Individual,
  Info,
  Info2,
  InvalidTarget,
  LeftArrow,
  Moms,
  Money,
  MoneyGreen,
  MonitorIcon,
  Mute,
  NaverApp,
  Notice,
  OverTaxLogo,
  Pen,
  PhoneRing,
  Question,
  Refresh,
  RefundProcess,
  RefundProgressBar,
  RelativeIcon,
  Review,
  RightAngleBracket,
  Shield,
  ShieldCheck,
  ShieldExclamation,
  Speak,
  Stars5,
  SurveyStart,
  TossApp,
  Triangle,
  UpAngleBracket,
  VideoPlayButton,
  Warning,
  XMark,
]

export {
  AddPlus,
  AgreementProgress,
  Alarm,
  AppendFile,
  Bell,
  Camera,
  CertGuide1,
  CertGuide2,
  CertGuide3,
  CertGuide4,
  CertGuide5,
  CertGuide6,
  CheckInBlueCircle,
  CheckInCircle,
  CheckMark,
  CircularProgress,
  Coin,
  CompanyIcon,
  CompanyIndividualIcon,
  CompletedIcon,
  Consult,
  Corporate,
  Dash,
  Delay,
  DetachFile,
  DoubleQuote,
  DownAngleBracket,
  EasyCertStep,
  ExclamationMark,
  Financial,
  HamburgMark,
  Hero1,
  Hero2,
  Hero3,
  Hero4,
  HeumOverTaxLogo,
  HomeTaxDelay,
  HeumTaxLogo,
  IDBack,
  IDFront,
  Individual,
  Info,
  Info2,
  InvalidTarget,
  LeftArrow,
  Moms,
  Money,
  MoneyGreen,
  MonitorIcon,
  Mute,
  NaverApp,
  Notice,
  OverTaxLogo,
  Pen,
  PhoneRing,
  Question,
  Refresh,
  RefundProcess,
  RefundProgressBar,
  RelativeIcon,
  Review,
  RightAngleBracket,
  Shield,
  ShieldCheck,
  ShieldExclamation,
  Speak,
  Stars5,
  SurveyStart,
  TossApp,
  Triangle,
  UpAngleBracket,
  VideoPlayButton,
  Warning,
  XMark,
}
